const Citydetails = {
  Agartala: {
    about:
      "Agartala is the capital city of the Indian state of Tripura, and is located in the north-eastern part of the country. It is known for its temples, palaces, and beautiful natural scenery.",
    image_url:
      "https://lh5.googleusercontent.com/p/AF1QipPmR9ANcAkWiV7tX5LaeS67eM8S--5SbFgR9nu4=w548-h318-n-k-no",
    place: "Agarta",
    spot: ["Neermahal", "Jagannath Temple"],
    map_link:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57727.139091168515!2d91.2729016331897!3d23.836776318981804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37506473f2da6a31%3A0x16f128f8e746d239!2sAgartala%2C%20Tripura!5e0!3m2!1sen!2sin!4v1650778365531!5m2!1sen!2sin",
  },
  Agra: {
    about:
      "Agra is a city in the northern Indian state of Uttar Pradesh, and is home to the iconic Taj Mahal, one of the most famous landmarks in the world. Agra is also known for its rich history and vibrant culture.",
    image_url:
      "https://encrypted-tbn2.gstatic.com/licensed-image?q=tbn:ANd9GcSJaW_VGJ7cUjoEsJc7C6wW3KUpgsCqH6YAssZxaNCz7zJ_hLOh6l6Vx2DCPk7sdUyTM0-0MCbTtW2hTis6L5TWMa_vlg",
    place: "Agra",
    spot: ["Taj Mahal", "Agra Fort", "Fatehpur Sikri"],
    map_link:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14021.539469064764!2d78.04022139208128!3d27.173891701859443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398bf09a06ca00b7%3A0x53f332959b5af83f!2sTaj%20Mahal%2C%20Dharmapuri%20Rd%2C%20Diana%20Ganj%2C%20Agra%2C%20Uttar%20Pradesh%20282002%2C%20India!5e0!3m2!1sen!2sin!4v1650778735171!5m2!1sen!2sin",
  },
  Ahmedabad: {
    about:
      "Ahmedabad is the largest city in the Indian state of Gujarat, and is known for its rich culture, history, and beautiful architecture. It is also a major economic and industrial hub in India.",
    image_url:
      "https://lh5.googleusercontent.com/p/AF1QipM9QqYF5EMQ9vD3MthfZxVhpo_4pXz0DNU5tbxW=w548-h318-n-k-no",
    place: "Ahmedabad",
    spot: ["Jama Masjid", "Adalaj Stepwell"],
    map_link:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4105458346777!2d72.57645491495687!3d23.0270074849601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcae56a3b9e4a29%3A0x77fa7c2a1a2a7c2e!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1620156397693!5m2!1sen!2sin",
  },
  Aizawl: {
    about:
      "Aizawl is the capital city of the Indian state of Mizoram, and is located in the north-eastern part of the country. It is known for its natural beauty, vibrant culture, and friendly people.",
    image_url: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Aizawl.jpg",
    place: "Aizawl",
    spot: ["Durtlang Hills", "Bara Bazaar"],
    map_link:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57935.17746313438!2d92.73525375388151!3d23.7271075768981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x373b9366f8c6a555%3A0x3260dc8b8d6e70c6!2sAizawl%2C%20Mizoram!5e0!3m2!1sen!2sin!4v1650781022231!5m2!1sen!2sin",
  },
  Ajmer: {},
  Almora: {},
  Amaravati: {},
  Ambala: {},
  Amritsar: {},
  Aurangabad: {},
  Ayodhya: {},
  Badrinath: {},
  Bangalore: {},
  Bhopal: {},
  Bhubaneswar: {},
  Bikaner: {},
  Bilaspur: {},
  Bodhgaya: {},
  Calangutegoa: {},
  Canaconagoa: {},
  Chandigarh: {},
  Chennai: {},
  Chittoor: {},
  Coimbatore: {},
  Dalhousie: {},
  Daman: {},
  Darjeeling: {},
  Dehradun: {},
  Delhi: {},
  Dharamshala: {},
  Dwarka: {},
  Fatehpursikri: {},
  Gandhinagar: {},
  Gangtoksikkim: {},
  Gurgaon: {},
  Guwahati: {},
  Gwalior: {},
  Hampi: {},
  Haridwar: {},
  Hyderabad: {},
  Imphal: {},
  Indore: {},
  Itanagar: {},
  Jabalpur: {},
  Jaipur: {},
  Jaisalmer: {},
  Jammu: {},
  Jhansi: {},
  Jodhpur: {},
  Junagadh: {},
  Kanpur: {},
  Kasauli: {},
  Kavaratti: {},
  Kedarnath: {},
  Kohima: {},
  Kolkata: {},
  Kufri: {},
  Kullu: {},
  Leh: {},
  Lucknow: {},
  Madurai: {},
  Manali: {},
  Mangalore: {},
  Mathura: {},
  Mumbai: {},
  Mussorie: {},
  Mysore: {},
  Nagpur: {
    about:
      "Nagpur is a city in the Indian state of Maharashtra, located in the central part of the country. It is known for its rich history, beautiful architecture, and vibrant culture.",
    image_url:
      "https://images.herzindagi.info/image/2022/Apr/best-places-to-visit-in-Nagpur.jpg",
    place: "Nagpur",
    spot: ["Deekshabhoomi", "Futala Lake", "Seminary Hill"],
    map_link:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d377143.93465902786!2d79.02492542703896!3d21.14663322808509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd3ff41f9c36b1d%3A0xe5a76f53a3c3e5d5!2sNagpur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1651012161996!5m2!1sen!2sin",
  },
  Nainital: {},
  Nashik: {},
  Ooty: {},
  Panajigoa: {},
  Patnabihar: {},
  Portblair: {},
  Prayagraj: {},
  Puducherry: {},
  Pune: {},
  Puri: {},
  Raipur: {},
  Ranchi: {},
  Rourkela: {},
  Rishikesh: {},
  Rohtak: {},
  Shillong: {},
  Shimla: {},
  Silchar: {},
  Silliguri: {},
  Sonipat: {},
  Surat: {},
  Tawang: {},
  Thiruvananthapuram: {},
  Tirupati: {},
  Udaipur: {},
  Vadodara: {},
  Varanasi: {},
  Vijayawada: {},
  Visakhapatnam: {},
  Vrindavan: {},
  Warangal: {},
};

export { Citydetails };
